// Modules / Functions
import { Breadcrumb } from "react-bootstrap";


// Icons / Images
import {
  BiBell,
  BiHelpCircle,
} from "react-icons/bi";
import {
  AiOutlineLogin,
} from "react-icons/ai";
import { GoLaw } from "react-icons/go";
import {
  FaDatabase,
  FaBriefcase,
  FaInfo,
  FaUser,
  FaArrowRight ,
  FaChartLine,
  FaWrench,
} from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";

export {
  formatDisplayDate,
  formatDisplayDateTime,
  DATE_INPUT_PLACEHOLDER,
  DISPLAY_DATE_LOCALE,
} from "./common/dateFormat";

export const iconStyle = {
  color: "#93ab3c",
  fontSize: "1.5em",
  marginRight: "0.5em",
};

// Loader
export const loader = () => {
  return (
    <div className="spinner">
      <span> Loading... </span>
      <div className="half-spinner"></div>
    </div>
  );
};

// Helper style
export const helpStyle = {
  borderRadius: 0,
  opacity: 0.9,
  padding: "1.5em",
  margin: 20,
};

// Headers
export const headers = {
  "Content-type": "Application/json",
  "Authorization": `Token ${localStorage.getItem('userToken')}`,
};

// Dynamic auth headers to always use the latest token value
export const authHeaders = () => ({
  "Content-type": "Application/json",
  "Authorization": `Token ${localStorage.getItem('userToken')}`,
});

export const rootIconStyle = {
  color: "#93ab3c",
  fontSize: "1.5em",
  marginRight: 20,
};

// Currency helpers
export function currencySymbol(code) {
  const c = String(code || '').toUpperCase();
  const map = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    JPY: '¥',
    CNY: '¥',
    CHF: 'CHF',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    PLN: 'zł',
    CZK: 'Kč',
    RON: 'lei',
    BGN: 'лв',
    HUF: 'Ft',
    TRY: '₺',
  };
  return map[c] || c || '';
}

export function formatAmountWithCurrency(amount, currencyCode) {
  const sym = currencySymbol(currencyCode);
  const n = (amount === null || amount === undefined || amount === '') ? null : Number(amount);
  if (n === null || Number.isNaN(n)) return '';
  try {
    // Keep simple formatting to avoid locale surprises
    return `${sym}${n.toFixed(2)}`;
  } catch (_) {
    return `${sym}${amount}`;
  }
}

// Pagination options for all tables
export const paginationOptions = {
  paginationSize: 7,
  pageStartIndex: 1,
  alwaysShowAllBtns: true,
  firstPageText: "First",
  prePageText: "Previous",
  nextPageText: "Next",
  lastPageText: "Last",
  nextPageTitle: "Next page",
  prePageTitle: "Previous page",
  firstPageTitle: "First page",
  lastPageTitle: "Last page",
  showTotal: true,
  disablePageTitle: false,
  sizePerPageList: [
    { text: "20", value: 20 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ],
};

/**
 * Page title + breadcrumb. Pass `meta` for extra navigation steps (list + parent entity links).
 * @param {string} value
 * @param {string} [objName]
 * @param {{ projectId?: string, clientId?: string }} [meta]
 */
export function pageHeader(value, objName, meta = {}) {
  if (value === "about") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaInfo style={iconStyle} /> About us
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>About us</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "help") {
    return (
      <>
        <div className="page_header">
          <h2>
            <BiHelpCircle style={iconStyle} /> Help
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/"> Home </Breadcrumb.Item>
            <Breadcrumb.Item active> Help </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "login") {
    return (
      <>
        <div className="page_header">
          <h2>
            <AiOutlineLogin style={{ iconStyle }} /> Login
          </h2>
        </div>
        <hr />
      </>
    );
  } else if (value === "terms") {
    return (
      <>
        <div className="page_header">
          <h2>
            <GoLaw style={iconStyle} />
            Terms and conditions
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Terms and conditions</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "notifications") {
    return (
      <>
        <div className="page_header">
          <h2>
            <BiBell style={iconStyle} />
            Notifications
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/help/">Help</Breadcrumb.Item>
            <Breadcrumb.Item active>Notifications</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "country_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Country Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/all_countries">All Countries</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  }  else if (value === "city_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> City Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/all_cities">All Cities</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_clients") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaBriefcase style={iconStyle} /> All Clients
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Clients</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_countries") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Countries
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Countries</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "client_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Client Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_client_contacts") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Client Contacts
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Client Contacts</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "client_contact_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Client Contact Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/all_client_contacts">All Client Contacts</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_bank_client_accounts") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Bank Client Accounts
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Bank Client Accounts</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
                } else if (value === "bank_client_account_overview") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Bank Client Account Overview
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_bank_client_accounts">All Bank Client Accounts</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "all_projects") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> All Projects
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>All Projects</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "project_overview") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Project Overview
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_projects">All Projects</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } 
              else if (value === "project_tasks") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Project Tasks
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_projects">All Projects</Breadcrumb.Item>
                        {meta.projectId ? (
                          <Breadcrumb.Item href={`/data_management/project/${encodeURIComponent(meta.projectId)}`}>
                            {objName || "Project"}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Tasks</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } 
              else if (value === "project_related") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Project Related Objects
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_projects">All Projects</Breadcrumb.Item>
                        {meta.projectId ? (
                          <Breadcrumb.Item href={`/data_management/project/${encodeURIComponent(meta.projectId)}`}>
                            {objName || "Project"}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Related objects</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } 

              else if (value === "administration_logs") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Administration Logs
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/administration/root">
                          Administration
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Administration Logs</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client Related Objects
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Related objects</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_projects") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Projects
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Projects</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_properties") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Properties
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Properties</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_bank_client_accounts") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Bank client accounts
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Bank client accounts</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_associated_clients") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Associated clients
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Associated clients</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_documents") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Documents
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Documents</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_cash") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Accounting
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Accounting</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_related_bank_project_accounts") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client — Bank project accounts
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">Data Management</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                        {meta.clientId ? (
                          <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                            {objName}
                          </Breadcrumb.Item>
                        ) : null}
                        <Breadcrumb.Item active>Bank project accounts</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }
              else if (value === "client_projects_properties") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Client Projects Properties
                      </h2>
                    <Breadcrumb>
                      <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                      <Breadcrumb.Item href="/data_management/root">
                        Data Management
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="/data_management/all_clients">All Clients</Breadcrumb.Item>
                      {meta.clientId ? (
                        <Breadcrumb.Item href={`/data_management/client/${encodeURIComponent(meta.clientId)}`}>
                          {objName}
                        </Breadcrumb.Item>
                      ) : null}
                      <Breadcrumb.Item active>Projects &amp; properties</Breadcrumb.Item>
                    </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              }

              else if (value === "all_associated_clients") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> All Associated Clients
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Associated Clients</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "associated_client_overview") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Associated Client Overview
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_associated_clients">All Associated Clients</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "all_task_comments") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> All Task Comments
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Task Comments</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "all_project_tasks") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> All Project Tasks
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Project Tasks</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "project_task_overview") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Project Task Overview
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_project_tasks">All Project Tasks</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "task_comment_overview") {
                return (
                  <>
                    <div className="page_header">
                      <h2>
                        <FaArrowRight style={iconStyle} /> Task Comment Overview
                      </h2>
                      <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/root">
                          Data Management
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/data_management/all_task_comments">All Task Comments</Breadcrumb.Item>
                        <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <hr />
                  </>
                );
              } else if (value === "all_cities") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Cities
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Cities</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_provinces") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Provinces
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Provinces</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "province_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Province Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/root">
              Regions
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/regions/all_provinces">All Provinces</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "data_management_root") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaDatabase style={iconStyle} /> Data Management
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active> Data Management </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "region_root") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaGlobe style={iconStyle} /> Regions
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active> Regions </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
    } else if (value === "administration_root") {
      return (
        <>
          <div className="page_header">
            <h2>
              <FaUser style={iconStyle} /> Administration
            </h2>
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active> Administration </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <hr />
        </>
      );
    } else if (value === "reports_root") {
      return (
        <>
          <div className="page_header">
            <h2>
              <FaChartLine style={iconStyle} /> Reports
            </h2>
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active> Reports </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <hr />
        </>
      );
  } else if (value === "all_consultants") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Consultants
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Consultants</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  }  else if (value === "consultant_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Consultant Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_consultants">All Consultants</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_banks") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Banks
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Banks</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "bank_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Bank Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_banks">All Banks</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_insurance_carriers") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Insurance Carriers
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Insurance Carriers</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "insurance_carrier_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Insurance Carrier Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_insurance_carriers">All Insurance Carriers</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_professions") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Professions
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Professions</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "profession_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Profession Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_professions">All Professions</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_project_categories") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Project Categories
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Project Categories</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "project_category_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Project Category Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_project_categories">All Project Categories</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_task_categories") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Task Categories
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Task Categories</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "task_category_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Task Category Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_task_categories">All Task Categories</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_document_categories") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Document Categories
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Document Categories</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "document_category_overview") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> Document Category Overview
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/root">
              Administration
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/administration/all_document_categories">All Document Categories</Breadcrumb.Item>
            <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "all_documents") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Documents
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Documents</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "documents") {
    return (
      <>
        <div className="page_header">
          <h2>
            <FaArrowRight style={iconStyle} /> All Documents
          </h2>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/data_management/root">
              Data Management
            </Breadcrumb.Item>
            <Breadcrumb.Item active>All Documents</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <hr />
      </>
    );
  } else if (value === "documents") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Documents
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Documents</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         } else if (value === "document_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Document Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_documents">All Documents</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         } else if (value === "cash_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Accounting Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_cash">All Accounting</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "all_cash") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Accounting
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Accounting</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "bank_project_account_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Bank Project Account Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_bank_project_accounts">All Bank Project Accounts</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "all_bank_project_accounts") {  
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Bank Project Accounts
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Bank Project Accounts</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "all_properties") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Properties
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Properties</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         } else if (value === "all_taxation_projects") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Taxation Projects
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Taxation Projects</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "taxation_project_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Taxation Project Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_taxation_projects">All Taxation Projects</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }
         else if (value === "all_professionals") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> All Professionals
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>All Professionals</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }  
         else if (value === "professional_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Professional Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_professionals">All Professionals</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         }  else if (value === "property_overview") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Property Overview
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/root">
                     Data Management
                   </Breadcrumb.Item>
                   <Breadcrumb.Item href="/data_management/all_properties">All Properties</Breadcrumb.Item>
                   <Breadcrumb.Item active>Overview of {objName}</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
               <hr />
             </>
           );
         } else if (value === "reports_clients") {
           return (
             <>
               <div className="page_header">
                 <h2>
                   <FaArrowRight style={iconStyle} /> Clients
                 </h2>
                 <Breadcrumb>
                   <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                   <Breadcrumb.Item href="/reports/root">
                     Reports
                   </Breadcrumb.Item>
                   <Breadcrumb.Item active>Clients</Breadcrumb.Item>
                 </Breadcrumb>
               </div>
             </>
           );
         } else if (value === "reports_projects") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Projects
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Projects</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_tasks") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Tasks
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Tasks</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_properties") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Properties
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Properties</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_documents") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Documents
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Documents</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_cash") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Accounting
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Accounting</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_professionals") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Professionals
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Professionals</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        } else if (value === "reports_statistics") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Statistics
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="/reports/root">Reports</Breadcrumb.Item>
                  <Breadcrumb.Item active>Statistics</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </>
          );
        }
        else if (value === "dashboard") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaArrowRight style={iconStyle} /> Dashboard
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <hr />
            </>
          );
        }
        else if (value === "tools") {
          return (
            <>
              <div className="page_header">
                <h2>
                  <FaWrench style={iconStyle} /> Tools
                </h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Tools</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <hr />
            </>
          );
        }
  return <></>;
}
